import { SendEventProps } from '../../interfaces/biEvents';

export const mpShowMoreClicked = () =>
    ({
        eventName: 'Gig page - about the gig - show more clicked',
    } satisfies SendEventProps);
